import { createSlice } from '@reduxjs/toolkit';
import { resolveTabKey } from './lib/resolveTabKey';
import { CHANNEL } from '../constants/messageTemplateKeys';

const emptyFilters = {
  status: [],
  language: [],
  type: [],
  channels: [],
  tags: [],
  campaigns: [],
};

export const TAGS_MODE = {
  INCLUDE: 'include',
  EXCLUDE: 'exclude',
};

const initialState = {
  activeTab: CHANNEL.EMAIL,
  search: '',
  ordering: '-modified',
  filters: emptyFilters,
  tagsMode: TAGS_MODE.INCLUDE,
  hasLoadedOnce: false,
  error: null,
};

export const templatesQuerySlice = createSlice({
  name: 'templatesQuery',
  initialState,
  reducers: {
    templatesSearchChanged(state, action) {
      state.search = String(action.payload ?? '');
    },
    templatesOrderingChanged(state, action) {
      state.ordering = String(action.payload ?? '-modified');
    },
    templatesFiltersChanged(state, action) {
      state.filters = action.payload ?? emptyFilters;
    },
    templatesTagsModeChanged(state, action) {
      const next = action.payload;
      state.tagsMode = next === TAGS_MODE.EXCLUDE ? TAGS_MODE.EXCLUDE : TAGS_MODE.INCLUDE;
    },
    templatesChannelTabChanged(state, action) {
      state.activeTab = resolveTabKey(action.payload ?? CHANNEL.EMAIL);
    },
    templatesErrorCleared(state) {
      state.error = null;
    },
    templatesErrorSet(state, action) {
      state.error = action.payload ?? null;
    },
    templatesHasLoadedOnceSet(state) {
      state.hasLoadedOnce = true;
    },
  },
});

export const selectTemplatesActiveTab = (state) => state.templates.query.activeTab;
export const selectTemplatesSearch = (state) => state.templates.query.search;
export const selectTemplatesOrdering = (state) => state.templates.query.ordering;
export const selectTemplatesFilters = (state) => state.templates.query.filters;
export const selectTemplatesTagsMode = (state) =>
  state.templates.query.tagsMode ?? TAGS_MODE.INCLUDE;
export const selectTemplatesHasLoadedOnce = (state) => Boolean(state.templates.query.hasLoadedOnce);
export const selectTemplatesError = (state) => state.templates.query.error;

export const {
  templatesSearchChanged,
  templatesOrderingChanged,
  templatesFiltersChanged,
  templatesTagsModeChanged,
  templatesChannelTabChanged,
  templatesErrorCleared,
  templatesErrorSet,
  templatesHasLoadedOnceSet,
} = templatesQuerySlice.actions;

export const templatesQueryReducer = templatesQuerySlice.reducer;
export const templatesEmptyFilters = emptyFilters;
